/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { each, isEmpty } from "lodash";
import DataComponent from "../DataComponent";
import TabList from "../Tab";
import { isFunction } from "lodash";
import { shallowEqual, useSelector } from "react-redux";

// tabItme = { label:String, action:Function }

const PageHeader = ({
  title,
  activeTab,
  tabList,
  buttons
}) => {

  const {
    taxContactType
  } = useSelector(
    (store) => ({
      taxContactType: store.TaxPortal.taxContactType
    }),
    shallowEqual
  );

  useEffect(() => {
    // tab 이나 buttons 가 있을떄 has-extend-header 클레스 주입 
    each(document.getElementsByClassName("main-content"), (elem) => {
      elem.classList[(!isEmpty(tabList) || !isEmpty(buttons)) ? "add" : "remove"]("has-extend-header");
    });

  }, [tabList, buttons]);

  useEffect(() => {
    // 세무 접근 타입이 변경 되면 실행
    console.log('[taxContactType] : ', taxContactType);

  }, [taxContactType]);


  return (
    <div className="page-header">
      {title &&
        <div className="page-title-box">
          <h1 className="page-title">
            {title}
          </h1>
        </div>
      }
      {(!isEmpty(tabList) || !isEmpty(buttons)) &&
        <div className="extend-header">
          {!isEmpty(tabList) && (
            <TabList
              tabList={tabList}
              active={activeTab}
            />
          )}
          {!isEmpty(buttons) && (
            <div className="header-button-wrap print-out">
              {buttons.map((button, idx) =>
                (isFunction(button.isHide) && button.isHide()) ||
                  (!isFunction(button.isHide) && button.isHide) ?
                  <React.Fragment key={`hide-button-${idx}`}></React.Fragment>
                  :
                  <DataComponent
                    key={idx}
                    field={{
                      type: 'button',
                      ...button
                    }}
                  />
              )}
            </div>
          )}
        </div>
      }
      {

      }
    </div>
  );
};

export default PageHeader;
